import React from 'react';
import LazyLoad from '@nykaa/lazy-load';
import { TipTile } from '@nykaa/listing-shared/type/product';
import { pushEvent } from 'helpers/utils/dataLayer';
import styled from 'App/styled';
import { TIPTILE_CLICKED } from './constants';

const Wrapper = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  img {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    height: 100%;
  }

  .tip-tile-lazy {
    width: 100%;
    height: 100%;
  }

  .tip-tile-place-holder {
    background: #eee;
    height: 100%;
    width: 100%;
  }
`;

const TipTilPlaceHolder = () => <div className="tip-tile-place-holder" />;

interface Props {
  tipTile: TipTile;
  tipTileData: {
    position: number;
  };
}

function TipTileCard({ tipTile, tipTileData }: Props) {
  const { imageSrc, url } = tipTile;

  const onTiptileClick = () => {
    pushEvent(TIPTILE_CLICKED, { tipTileData });
  };

  return (
    <Wrapper
      key={url}
      href={url}
      onClick={onTiptileClick}
    >
      <LazyLoad
        placeHolder={<TipTilPlaceHolder />}
        bottomMargin={600}
        wrapperClassName="tip-tile-lazy"
      >
        <img
          src={imageSrc}
          alt="tip-tile"
        />
      </LazyLoad>
    </Wrapper>
  );
}

export default TipTileCard;
